import { register } from 'swiper/element/bundle';
// register Swiper custom elements
document.addEventListener("turbo:load", () => register());
register();
window.register = register;
console.log("swiper registered");